export default __webpack_public_path__ + "static/media/thumbnail.0fe67f34.png";